import { render, staticRenderFns } from "./EditWidgetCommentsPlusDialog.vue?vue&type=template&id=cf710068&scoped=true"
import script from "./EditWidgetCommentsPlusDialog.vue?vue&type=script&lang=js"
export * from "./EditWidgetCommentsPlusDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWidgetCommentsPlusDialog.vue?vue&type=style&index=0&id=cf710068&prod&scoped=true&lang=sass"
import style1 from "./EditWidgetCommentsPlusDialog.vue?vue&type=style&index=1&id=cf710068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf710068",
  null
  
)

export default component.exports